<template>  
  <v-flex v-if="mission" class="mission-page"  >        
    <cache-all-graphics-list :isleft="true" :uiid="`CacheAllGraphicsList-0`" />
  </v-flex>
</template>
<script>
  import { mapGetters } from 'vuex'
  import CacheAllGraphicsList from '@/components/cache/CacheAllGraphicsList'  
  export default {
   name: 'CachePage',   
   components:{CacheAllGraphicsList},
   props: {       
     missionid:Number
   },
    data() {
      return {   
        isTransitionActive:false          
      }
   },          
   computed: {
       ...mapGetters([   
         'currentDetailMission',
         'isDrawerOpen',
         'isRightDrawerOpen',
         'uistatebyuiid'
      ]),
      showDrawer: {
        get(){
          return this.isDrawerOpen
        },
        set(newValue) {
          this.$store.myActions.UI_SET_DRAWER_VISIBILITY(newValue)
        }
      },
      showRightDrawer:{
        get(){          
          return this.isRightDrawerOpen
        },
        set(newValue) {          
          this.$store.myActions.UI_SET_RIGHT_DRAWER_VISIBILITY(newValue)
        }
      },           
      mission() {        
        return this.currentDetailMission && this.currentDetailMission.mission
      },   
      mission_uiid() {
        return buildMissionUIStateId(this.mission.misId,"detail")
      },
      //recupere le state de travail
      missionState() { 
        //retourne un MapUiState
        return this.uistatebyuiid(this.mission_uiid)          
      },
      clipped(){
        return this.$vuetify.breakpoint.name == 'xs' ||
              this.$vuetify.breakpoint.name == 'sm'
      }
    },
    watch:{
      $route (to, from){        
        this.$store.myActions.MISSION_SELECT_DETAIL_REQUEST(this.missionid)
      }
    },
    created(){      
      this.$store.myActions.MISSION_SELECT_DETAIL_REQUEST(this.missionid)      
    },
    methods: {      
      toggleRightDrawer() {        
        if(this.clipped) this.showDrawer = false
        this.showRightDrawer = !this.showRightDrawer
      }      
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  

  .mission-page{
    background-color:#ddd;
    display:flex;
    flex-direction:column;
    flex-grow:1
  }

</style>